import moment from "moment"
import CompanyController from "../controllers/CompanyController"
import FidelityController from "../controllers/FidelityController"
import PopupController from "../controllers/PopupController"
import ComboController from "../controllers/ComboController"
import ProductController from "../controllers/ProductController"
import BeverageController from "../controllers/BeverageController"
import HighlightsController from "../controllers/HighlightsController"
import ScheduleController from "../controllers/ScheduleController"
import CustomerController from "../controllers/CustomerController"
import { getLocalItem, setLocalItem, removeLocalItem, removeSessionItem, getSessionItem, setCookie } from "../helpers/StorageTools"
import { formatBoolean, getUrlAWSManagerFile } from "../helpers/GeneralTools"
import { checkBetweenIntervalPeriod } from "../helpers/DateTools"
import { getLocalUser } from "../helpers/UserTools"
import { getProductName } from "../helpers/BuilderTools"

const useInitialLoad = ({
  setCompany,
  setSettings,
  setProducts,
  setCombos,
  setBeverages,
  setHighlights,
  setSchedules,
  setFidelities,
  setModalInitialAddress,
  setModalCompanies,
  setOrder,
  setCurrentOrderCombo,
  setLoading,
  setIsContentLoading,
  setUser,
  setUserSelectedAddress,
  setModality,
  setCompanies,
  companyRef,
  userRef,
  userSelectedAddressRef,
  groupFidelitiesRef,
  menuOptionsRef,
  defaultPaymentMethodIdRef,
  setSelectedPaymentMethod,
  setMenuOptions,
  modality,
  userSelectedAddress,
  modalCompanies,
  removeCookie,
}) => {
  const onSignOut = () => {
    sessionStorage.clear()
    removeLocalItem("user")
    setUserSelectedAddress(null)
    setUser(null)
    setOrder((prev) => ({ ...prev, benefits: [] }))
    if (removeCookie) removeCookie("customerToken")
  }

  const fetchInitialData = async (company, startLoad = false, refreshOrder = false, companies = [], callbacks = {}) => {
    const { onChangeFavicon, onChangeTitlePage, addMenuOption, updateMenuOptions, removeMenuOption, onChangeUserSelectedAddress } = callbacks

    let localUser = getLocalUser()

    const group = getLocalItem("group")
    const database = getLocalItem("database")
    const previousDatabase = database
    if (!!group && group !== "null" && !!company && !!database && !!company.database && database !== company?.database && !!company.subscriber) {
      console.info("Trocou database para", company.database)
      setLocalItem("database", company.database)
      await setCookie("publicToken", company.subscriber.ds_access_token)
    }

    let focusMenuOption = true
    setCompany(company)
    companyRef.current = company
    setLocalItem("company", company, true)

    let storageCompanies = getLocalItem("companies", true)

    if (!storageCompanies && companies.length > 0) {
      storageCompanies = companies
      setLocalItem("companies", companies, true)
    }

    setCompanies(storageCompanies)

    let orderItems = getLocalItem("orderItems", true) || []
    let newOrderItems = []

    if (refreshOrder) {
      setOrder({
        customer: null,
        combos: [],
        products: [],
        beverages: [],
        payments: [],
        benefits: [],
        total: 0.0,
        subTotal: 0.0,
        comments: "",
        discount: "0,00",
        discountType: "R$",
        deliveryFee: 0,
        deliveryComments: "",
      })
      removeSessionItem("order")
    } else {
      const sessionOrder = getSessionItem("order", true)
      if (!!sessionOrder) {
        if (!!sessionOrder.combos && sessionOrder.combos.length > 0) {
          const comboNroList = sessionOrder.combos.map(({ nro_combo }) => nro_combo)
          const maxComboNro = Math.max(...comboNroList)
          setCurrentOrderCombo(maxComboNro)
        }
        setOrder({ ...sessionOrder })
      }
    }

    console.info("CONSULTANDO DADOS DE CONFIGURAÇÕES DO ESTABELECIMENTO...")
    const settingsStorage = getLocalItem("settings", true)

    if (!!settingsStorage) {
      setLoading(false)
      setSettings(settingsStorage)

      if (startLoad) {
        const userAddress = getLocalItem("userSelectedAddress", true)
        if (formatBoolean(settingsStorage.site_get_address_on_early_access)) {
          if (!userAddress) {
            setModalInitialAddress({ status: true, content: { source: "mainOptions" } })
          } else {
            if (formatBoolean(settingsStorage.site_display_company_choose) && companies.length > 1) {
              if (modalCompanies.status === false) {
                setModalCompanies({ status: true, content: storageCompanies })
              }
            }
          }
        } else if (formatBoolean(settingsStorage.site_display_company_choose) && storageCompanies.length > 1) {
          setModalCompanies({ status: true, content: storageCompanies })
        }
      }

      if (!!settingsStorage.site_show_order) {
        orderItems = JSON.parse(settingsStorage.site_show_order)
        setLocalItem("orderItems", orderItems, true)
      }

      onChangeFavicon(getUrlAWSManagerFile(settingsStorage.site_favicon))
      onChangeTitlePage(settingsStorage.site_title || company.nm_company || "Estabelecimento")
    } else {
      setLoading(true)
    }

    // Carregar dados da empresa e configurações (Otimizado)
    const criticalPromise = Promise.all([CompanyController.fetchInitialData()])

    // Separando requisições secundárias (conteúdo)
    const secondaryPromise = Promise.all([
      PopupController.fetchAll(),
      ComboController.fetchAll({ stWebsite: true }),
      ProductController.fetchOptimized(),
      BeverageController.fetchInitial(),
      HighlightsController.fetchAll(),
      ScheduleController.fetchAll(),
    ])

    // Executando críticas primeiro
    await criticalPromise
      .then(([responseInitialData]) => {
        if (responseInitialData.status === 200) {
          const { company: companyData, payments, workingPeriods, workingHours, paymentCategories, settings } = responseInitialData.data

          // Process Settings
          if (startLoad) {
            const companies = getLocalItem("companies", true)
            const userAddress = getLocalItem("userSelectedAddress", true)

            if (formatBoolean(settings.site_get_address_on_early_access)) {
              if (!userAddress) {
                setModalInitialAddress({ status: true, content: { source: "mainOptions" } })
              } else {
                if (formatBoolean(settings.site_display_company_choose) && companies.length > 1) {
                  if (modalCompanies.status === false) {
                    setModalCompanies({ status: true, content: companies })
                  }
                }
              }
            } else if (formatBoolean(settings.site_display_company_choose) && companies.length > 1) {
              if (modalCompanies.status === false || userAddress === null) {
                setModalCompanies({ status: true, content: companies })
              }
            }
          }

          onChangeFavicon(getUrlAWSManagerFile(settings.site_favicon))
          onChangeTitlePage(settings.site_title || company.nm_company || "Restaurante")

          if (!!settings.site_show_order) {
            orderItems = JSON.parse(settings.site_show_order)
            setLocalItem("orderItems", orderItems, true)
          }
          setSettings(settings)
          setLocalItem("settings", settings, true)
          console.log("storageCompanies", storageCompanies)
          // Process Company Data
          company = { ...company, ...companyData, payment_status: "idle" }

          if (!companyRef.current?.company_modality?.find(({ fk_id_modality }) => fk_id_modality === 1)) {
            setUserSelectedAddress(null)
            setLocalItem("userSelectedAddress", null, true)
            userSelectedAddressRef.current = null
            setModality(2)
          }

          let enabledPayments = payments
            .filter((method) => method.st_website)
            .map((method) => {
              if (`${method.payment_method.nm_payment_method}`.toLowerCase() === "desconto") {
                defaultPaymentMethodIdRef.current = {
                  id_payment_method: method.payment_method.id_payment_method,
                  nm_payment_method: method.payment_method.nm_payment_method,
                }
                setSelectedPaymentMethod(defaultPaymentMethodIdRef.current)
              }
              return {
                ds_key_payment_method: method.ds_key_payment_method,
                ds_key_type_payment_method: method.ds_key_type_payment_method,
                ds_obs_payment_method: method.ds_obs_payment_method,
                ...method.payment_method,
              }
            })
          company = { ...company, company_payment_methods: enabledPayments }

          company = { ...company, company_working_periods: workingPeriods }
          company = { ...company, company_working_hours: workingHours }
          company = { ...company, company_payment_categories: paymentCategories }

          setCompany(company)
          companyRef.current = company
          setLocalItem("company", company, true)

          // Revalidação do endereço da empresa (self-healing do cache).
          // O cache de "companies" no localStorage — única fonte de company_address —
          // só era buscado na primeira visita e nunca mais era atualizado. Assim, quem
          // já tinha acessado o site continuava vendo o endereço antigo mesmo após a loja
          // atualizá-lo. Aqui revalidamos em background (sem bloquear o first paint) e,
          // se o endereço mudou, aplicamos ao estado, ao ref e ao localStorage.
          const companyIds = getLocalItem("companyIds", true) || []
          CompanyController.fetchAll(true, companyIds)
            .then((responseCompanies) => {
              if (responseCompanies.status === 200 && Array.isArray(responseCompanies.data)) {
                const freshCompanies = responseCompanies.data

                setLocalItem("companies", freshCompanies, true)
                setCompanies(freshCompanies)

                const freshCompany = freshCompanies.find((c) => c.id_company === companyData.id_company)
                const freshAddress = freshCompany?.company_address

                // Só aplica se a company atual ainda for a mesma desta carga — o usuário
                // pode ter trocado de loja enquanto este fetch estava em voo, e nesse caso
                // aplicar o endereço aqui contaminaria a company selecionada.
                if (
                  !!freshAddress &&
                  companyRef.current?.id_company === companyData.id_company &&
                  JSON.stringify(freshAddress) !== JSON.stringify(companyRef.current?.company_address)
                ) {
                  const updatedCompany = { ...companyRef.current, company_address: freshAddress }
                  setCompany(updatedCompany)
                  companyRef.current = updatedCompany
                  setLocalItem("company", updatedCompany, true)
                }
              }
            })
            .catch((error) => {
              console.error("Falha ao revalidar endereço da empresa", error)
            })
        }
      })
      .catch((error) => {
        console.error("Erro ao carregar dados iniciais:", error)
      })
      .finally(() => {
        setLoading(false)
      })

    // Carregar dados do Storage (Cache) para exibição imediata
    const combosSession = getLocalItem("combos", true)
    if (!!combosSession) {
      newOrderItems.push({
        companyId: company.id_company,
        id: "combos",
        label: "Combos",
        focus: focusMenuOption,
        position: newOrderItems.length,
        visible: combosSession.length > 0,
      })
      focusMenuOption = false
      setCombos(combosSession)
    }

    const productsSession = getLocalItem("products", true)
    if (!!productsSession) {
      for (const product of productsSession) {
        if (product?.flavours?.length > 0 || product?.sizes?.length > 0) {
          newOrderItems.push({
            companyId: company.id_company,
            id: product.uuid_product,
            label: getProductName(product),
            focus: focusMenuOption,
            position: newOrderItems.length,
            visible: product.st_website,
          })
          focusMenuOption = false
        }
      }
      setProducts(productsSession)
    }

    const beveragesSession = getLocalItem("beverages", true)
    if (!!beveragesSession) {
      newOrderItems.push({
        companyId: company.id_company,
        id: "beverages",
        label: "Bebidas",
        focus: focusMenuOption,
        position: newOrderItems.length,
        visible: beveragesSession.length > 0,
      })
      focusMenuOption = false
      setBeverages([...beveragesSession])
    }

    const highlightsSession = getLocalItem("highlights", true)
    if (!!highlightsSession) {
      newOrderItems.push({
        companyId: company.id_company,
        id: "highlights",
        label: "Destaques",
        focus: focusMenuOption,
        position: newOrderItems.length,
        visible: highlightsSession.length > 0,
      })
      focusMenuOption = false
      setHighlights(highlightsSession)
    }

    updateMenuOptions(newOrderItems)
    newOrderItems = [] // Zerando para atualizar Menu com itens atualizados vindos do banco

    const schedulesSession = getLocalItem("schedules", true)
    if (Array.isArray(schedulesSession)) {
      setSchedules([...schedulesSession])
    }

    // Executando secundárias em background
    secondaryPromise
      .then(async ([responsePopups, responseCombos, responseProducts, responseBeverages, responseHighlights, responseSchedule]) => {
        const validMenuOptionIds = new Set()

        if (!!localUser) {
          setUser(localUser)
          userRef.current = localUser

          let user = localUser

          //Caso já tenha usuário logado, busca novamente os dados dele para atualizar quaisquer informações que possam
          //ter sido alteradas como pontos de fideldiade, endereços e no futuro cupons
          CustomerController.fetchMe({
            withOrders: true,
            withStreets: true,
            withMovements: true,
            withFidelities: true,
            withLastOrder: true,
            localUser: {
              previousDatabase,
              uuid_customer: localUser.uuid_customer,
              nm_customer: localUser.nm_customer,
              dt_birth: localUser.dt_birth,
              contacts: localUser.contacts,
              customer_contacts: localUser.customer_contacts,
              addresses: localUser.addresses,
              customer_address: localUser.customer_address,
              password: localUser.password,
            },
          })
            .then(async (responseCustomer) => {
              if (responseCustomer.status === 200) {
                if (responseCustomer?.data?.dt_blocked_at) {
                  console.error("Usuário não autorizado, limpando dados do usuário")
                  setUser(null)
                  userRef.current = null
                  setUserSelectedAddress(null)
                  setLocalItem("userSelectedAddress", null, true)
                  userSelectedAddressRef.current = null
                  setLocalItem("user", null, true)

                  sessionStorage.clear()
                  removeLocalItem("user")
                  setOrder({
                    customer: null,
                    combos: [],
                    products: [],
                    beverages: [],
                    payments: [],
                    benefits: [],
                    total: 0.0,
                    subTotal: 0.0,
                    comments: "",
                    discount: "0,00",
                    discountType: "R$",
                    deliveryFee: 0,
                    deliveryComments: "",
                  })
                  removeSessionItem("order")
                } else {
                  const addresses = responseCustomer.data?.streets || []
                  const customer_orders = responseCustomer.data?.customer_orders
                  const fidelities = responseCustomer.data?.customer_fidelities_points || []
                  const movements_account = responseCustomer.data?.movements_account || []
                  const last_active_order = responseCustomer.data?.last_active_order || null

                  const cashbackUsed = getLocalItem("cashbackUsed")
                  if (movements_account.length > 0 && cashbackUsed) {
                    const [dateUsed, val_used] = cashbackUsed.split("__")
                    for (const movement of movements_account) {
                      const { type_movement_customer_account, dt_deleted_at } = movement
                      if (!dt_deleted_at && type_movement_customer_account === "output") {
                        const { dt_created_at } = movement
                        const sameDay = moment(dateUsed).isSame(dt_created_at, "D")
                        const sameMonth = moment(dateUsed).isSame(dt_created_at, "M")
                        const sameYear = moment(dateUsed).isSame(dt_created_at, "Y")
                        if (sameDay && sameMonth && sameYear) {
                          const { val_movement } = movement
                          if (parseFloat(Number.parseFloat(val_used).toFixed(2)) === val_movement) {
                            removeLocalItem("cashbackUsed")
                          }
                        }
                      }
                    }
                  }

                  if (addresses.length > 0) {
                    const defaultAddress =
                      addresses.find(({ customer_address: { st_primary, dt_deleted_at } }) => st_primary && !dt_deleted_at) || addresses[0]

                    if (
                      !userSelectedAddress?.nm_street &&
                      modality !== 2 &&
                      modality !== 3 &&
                      !!companyRef.current?.company_modality?.find(({ fk_id_modality }) => fk_id_modality === 1)
                    ) {
                      setModality(1)
                      setLocalItem("modality", 1)
                      onChangeUserSelectedAddress(defaultAddress, false, null, true).then()
                    }
                  }

                  setUser({ ...user, customer_orders, addresses, fidelities, movements_account, last_active_order })
                  userRef.current = { ...user, customer_orders, addresses, fidelities, movements_account, last_active_order }
                  setLocalItem("user", { ...user, customer_orders, addresses, fidelities, movements_account, last_active_order }, true)
                }
              }

              if (responseCustomer.status === 403) {
                onSignOut()
              }
            })
            .catch((error) => {
              console.error("Falha ao atualizar dados do cliente", error)
              setUser(user)
              userRef.current = user
            })
        }

        // Popups
        if (responsePopups.status === 200) {
          setLocalItem("popups", responsePopups, true)
        }

        // Combos
        const currentDate = moment()
        if (responseCombos.status === 200) {
          const combosData = responseCombos.data.rows || responseCombos.data || []
          if (combosData.length > 0) {
            const combosFiltered = combosData
              .filter(({ combo_periods = [] }) => checkBetweenIntervalPeriod(currentDate, combo_periods, "combos_periods_times"))
              .sort((a, b) => a.nro_priority - b.nro_priority)

            if (!combosSession) {
              focusMenuOption = false
            } else if (combosFiltered.length === 0) {
              const option = menuOptionsRef.current.find((option) => option.id === "combos")
              if (option) {
                option.visible = false
              }
            }

            newOrderItems.push({
              companyId: company.id_company,
              id: "combos",
              label: "Combos",
              focus: focusMenuOption,
              position: newOrderItems.length,
              visible: combosFiltered.length > 0,
            })

            setCombos(combosFiltered)
            setLocalItem("combos", combosFiltered, true)
          } else {
            setCombos([])
            setLocalItem("combos", [], true)
          }
        }

        // PRODUTOS - OTIMIZAÇÃO
        if (responseProducts.status === 200) {
          const validProducts = []

          for (const product of responseProducts.data.rows) {
            if (
              !(product.st_period_control
                ? !!product.products_periods && product.products_periods.length === 7
                  ? !!checkBetweenIntervalPeriod(currentDate, product.products_periods, "products_periods_times")
                  : true
                : true) ||
              !product.st_website
            ) {
              continue
            }

            if (product.flavours?.length) {
              product.flavours.sort((a, b) => a.nro_priority - b.nro_priority)
            }

            validProducts.push(product)
          }

          validProducts.sort((a, b) => a.nro_priority - b.nro_priority)

          setProducts(validProducts)
          setLocalItem("products", validProducts, true)

          const validProductIds = new Set()
          validProducts.forEach((product) => {
            if (product?.flavours?.length > 0 || product?.sizes?.length > 0) {
              validProductIds.add(product.uuid_product)
              validMenuOptionIds.add(product.uuid_product)
            }
          })

          const currentProductMenuOptions = menuOptionsRef.current.filter(
            (opt) => opt.companyId === company.id_company && opt.id !== "combos" && opt.id !== "beverages" && opt.id !== "highlights"
          )

          currentProductMenuOptions.forEach((menuOption) => {
            if (!validProductIds.has(menuOption.id)) {
              removeMenuOption(menuOption.id)
            }
          })

          validProducts.forEach((product) => {
            if (product?.flavours?.length > 0 || product?.sizes?.length > 0) {
              newOrderItems.push({
                companyId: company.id_company,
                id: product.uuid_product,
                label: getProductName(product),
                focus: focusMenuOption,
                position: newOrderItems.length,
                visible: true,
              })
            }
          })
        }

        // Beverages
        if (responseBeverages.status === 200 && responseBeverages.data.length > 0) {
          const beverages = responseBeverages.data
          newOrderItems.push({
            companyId: company.id_company,
            id: "beverages",
            label: "Bebidas",
            focus: focusMenuOption,
            position: newOrderItems.length,
            visible: beverages.length > 0,
          })
          focusMenuOption = false

          // Verificando se existe a opção sem bebida
          const beveragesFiltered = beverages
            .filter(
              ({ nm_beverage, beverages_periods }) =>
                `${nm_beverage}`.toLowerCase().indexOf("sem b") === -1 &&
                `${nm_beverage}`.toLowerCase().indexOf("sem r") === -1 &&
                (!!beverages_periods && beverages_periods.length === 7
                  ? !!checkBetweenIntervalPeriod(currentDate, beverages_periods, "beverages_periods_times")
                  : true)
            )
            .sort((a, b) => a.nro_priority - b.nro_priority)
          setBeverages(beveragesFiltered)
          setLocalItem("beverages", beveragesFiltered, true)
        } else {
          setBeverages([])
          setLocalItem("beverages", [], true)
        }

        // Highlights
        if (responseHighlights.status === 200) {
          const fetchedHighlights = responseHighlights.data.rows
          setHighlights(fetchedHighlights)
          setLocalItem("highlights", fetchedHighlights, true)

          if (fetchedHighlights.length > 0) {
            newOrderItems.push({
              companyId: company.id_company,
              id: "highlights",
              label: "Destaques",
              focus: focusMenuOption,
              position: newOrderItems.length,
              visible: true,
            })
          }
        }

        // Schedules
        if (responseSchedule.status === 200) {
          const schedulesData = Array.isArray(responseSchedule.data) ? responseSchedule.data : []
          setSchedules(schedulesData)
          setLocalItem("schedules", schedulesData, true)
        }
      })
      .catch((error) => {
        console.error(error)
        setIsContentLoading(false)
      })
      .finally(() => {
        setIsContentLoading(false)
      })

    // Carregamento de fidelidades em background (não bloqueante)
    FidelityController.fetchAll().then((responseFidelities) => {
      if (responseFidelities.status === 200) {
        setFidelities(responseFidelities.data)
        for (let fidelity of responseFidelities.data) {
          if (fidelity.nm_fidelity_group) {
            if (!groupFidelitiesRef.current[fidelity.nm_fidelity_group]) {
              groupFidelitiesRef.current[fidelity.nm_fidelity_group] = [fidelity.id_fidelity]
            } else {
              groupFidelitiesRef.current[fidelity.nm_fidelity_group].push(fidelity.id_fidelity)
            }
          }
        }

        //Validando se existe
        let fidelityUsageControl = getLocalItem("fidelityUsageControl", true) || {}
        let newFidelityUsageControl = {}
        for (let index = 0; index < Object.keys(fidelityUsageControl).length; index++) {
          const fidelityId = Object.keys(fidelityUsageControl)[index]
          const fidelityUsage = Object.values(fidelityUsageControl)[index]
          const newFidelityUsage = []
          for (const item of fidelityUsage) {
            const currentTime = Date.now()
            const usageTime = typeof item.usedAt === "number" ? item.usedAt : new Date(item.usedAt).getTime()
            const hoursPassed = (currentTime - usageTime) / (1000 * 60 * 60)
            if (hoursPassed < 24) {
              newFidelityUsage.push(item)
            }
          }
          if (newFidelityUsage.length > 0) {
            newFidelityUsageControl[fidelityId] = newFidelityUsage
          }
        }
        setLocalItem("fidelityUsageControl", newFidelityUsageControl, true)
      }
    })

    updateMenuOptions(newOrderItems)
  }

  return { fetchInitialData }
}

export default useInitialLoad
